// src/components/pages/EventManager/atoms/CustomButton.js

import React from "react";
import { Button } from "@mui/material";
import PropTypes from "prop-types";

const CustomButton = ({
  children,
  disabled,
  onClick,
  variant = "contained",
  theme,
  sx,
}) => {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: theme.colors.blue,
        color: "white",
        padding: "10px 30px",
        fontFamily: "basic-sans",
        fontWeight: "bold",
        textTransform: "none",
        borderRadius: "50px",
        boxShadow: "none",
        "&:hover": {
          backgroundColor: theme.colors.green,
          boxShadow: "none",
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

CustomButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.string,
  theme: PropTypes.object,
  sx: PropTypes.object,
};

export default CustomButton;
